import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setAuthData } from "./authSlice";
import { getOrCreateGuestCartId } from "../../helper/Common";

const AuthInitializer = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const authData = localStorage.getItem("auth");
    if (authData) {
      try {
        const { user, token } = JSON.parse(authData);
        dispatch(setAuthData({ user, token }));
      } catch (error) {
        localStorage.removeItem("auth");
      }
    } else {
      getOrCreateGuestCartId();
    }
  }, [dispatch]);

  return children;
};

export default AuthInitializer;
